"use strict";

import {getConfigValue, requireConfigValues} from '@elements/config-utils';
import fetch from "@elements/fetch";
import 'url-search-params-polyfill'; // Edge Polyfill
import initModulesInScope from '@elements/init-modules-in-scope';
import formDataEntries from 'form-data-entries';
import {showNotification} from '@elements/alert-notification';

export function initInScope ($scope) {
    let  $resultContainer = $scope.find('.js-my-store__result'),
         $resultLoading = $scope.find('.js-my-store__loading');

    requireConfigValues(['myStoreUrl'], '_storeConfig');

    $scope.find('.js-my-store__button').on('click', function (e) {
        let $this = $(this),
            id = $this.data('id'),
            $form = $($this.data('form'));

        $resultLoading.attr('hidden', null);

        const data = new URLSearchParams(formDataEntries($form[0]));
        data.append('id', id);

        let request = fetch(getConfigValue('myStoreUrl', '_storeConfig'), {
            method: 'get',
            body: data
        });

        showNotification(request);

        request.then(response => response.json())
            .then(result => {
                if (result.success) {
                    $resultContainer.empty().append(result.content);
                    initModulesInScope($scope);
                }else{
                    showNotification({
                        type: 'danger',
                        content: result.errorText,
                        closable: true
                    });
                }
                $resultLoading.attr('hidden', 'hidden');
            }).catch(e => {
            $resultLoading.attr('hidden', 'hidden');
            console.warn(e);
        });
    });
}